var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWildfire({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fit: "",
    preserveAspectRatio: "xMidYMid meet",
    focusable: "false",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.585 21C16.222 21 19 18.096 19 14.515c0-1.677-.264-2.899-.793-3.666-.193 1.424-.353 2.337-.48 2.74-.422 1.345-.88 1.405-1.024.926-.314-1.042.668-3.873-.824-6.722C14.697 5.538 12.586 3.94 9.546 3c1.453 1.47 2.18 3.241 2.18 5.311 0 1.263-.605 2.212-1.816 2.847.062-.935.062-1.602 0-2-.183-1.172-.695-2.04-1.538-2.602.122 1.65.059 2.794-.188 3.435C7.551 11.637 6 12.47 6 14.515 6 18.096 8.948 21 12.585 21z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWildfire);
export default __webpack_public_path__ + "static/media/wildfire.442d375ff77c5862d2047d346eee7a5f.svg";
export { ForwardRef as ReactComponent };